export const ADDRESSES = "/addresses";
export const EDIT_ADDRESS = `${ADDRESSES}/:id`;
export const CREATE_ADDRESS = `${ADDRESSES}/create`;

export const GROUPS = "/groups";
export const EXPORTS = "/exports";
export const EDIT_GROUP = `${GROUPS}/:groupId?`;
export const CREATE_GROUP = `${GROUPS}/create`;
